import axios from 'axios';

import { apiInstance } from 'api/instance';
import { setLoading } from 'store/slices/loader';
import { transformClockInOutData } from 'pages/analytics/team/helpers';

import { URL } from '../constants';

const backendURL = process.env.REACT_APP_SUBSCRIPTION_URL;

export const getSubscribersDetails = async (
  id: string | number | undefined,
  token: any,
  page: number,
  pageSize: number,
  searchQuery: string,
  startDate: Date | string | null,
  endDate: Date | string | null
) => {
  try {
    const response = await axios.get(
      `${backendURL}/${URL.GET_SUBSCRIPTION_MANAGEMENT}/${id}/subscription/history/?page=${page}&pageSize=${pageSize}&range[createdAt][start]=${startDate}&range[createdAt][end]=${endDate}&commonSearch=${searchQuery}`,
      {
        headers: {
          hospital_id: id,
          Authorization: token,
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error fetching subscription details:', error);
    throw error;
  }
};

export const getSubscribersEarnings = async (
  id: string | number | undefined,
  token: any,
  startDate: Date | string | null,
  endDate: Date | string | null
) => {
  try {
    const response = await axios.get(
      `${backendURL}/${URL.GET_SUBSCRIPTION_MANAGEMENT}/${id}/subscription/earning/?range[createdAt][start]=${startDate}&range[createdAt][end]=${endDate}`,
      {
        headers: {
          hospital_id: id,
          Authorization: token,
        },
      }
    );
    return response;
  } catch (error) {
    console.error('Error fetching subscription details:', error);
    throw error;
  }
};

export const getProfileDetails = async (
  id: string | number | undefined,
  token: any,
  dispatch: any,
  userId: string
) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.get(
      `${backendURL}/${URL.GET_SUBSCRIPTION_PROFILE_DETAILS}/${userId}`,
      {
        headers: {
          hospital_id: id,
          Authorization: token,
        },
      }
    );
    dispatch(setLoading(false));
    return response;
  } catch (error) {
    dispatch(setLoading(false));
    console.error('Error fetching subscription details:', error);
    throw error;
  }
};

export const getProfileDetailRequests = async (
  id: string | number | undefined,
  token: any,
  dispatch: any,
  userId: string
) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.get(
      `${backendURL}/${URL.GET_SUBSCRIPTION_PROFILE_REQUEST}/${userId}`,
      {
        headers: {
          hospital_id: id,
          Authorization: token,
        },
      }
    );
    dispatch(setLoading(false));
    return response;
  } catch (error) {
    dispatch(setLoading(false));
    console.error('Error fetching subscription details:', error);
    throw error;
  }
};

export const getTranscationDetails = async (
  id: string | number | undefined,
  token: any,
  dispatch: any,
  subscriptionId: string
) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.get(
      `${backendURL}/${URL.GET_SUBSCRIPTION_MANAGEMENT}/${id}/subscription/${subscriptionId}/history/details`,
      {
        headers: {
          hospital_id: id,
          Authorization: token,
        },
      }
    );
    dispatch(setLoading(false));
    return response;
  } catch (error) {
    dispatch(setLoading(false));
    console.error('Error fetching subscription details:', error);
    throw error;
  }
};

export const getSubscriptionHistory = async (
  id: string | number | undefined,
  token: any,
  dispatch: any,
  subscriptionId: string
) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.get(
      `${backendURL}/${URL.GET_SUBSCRIPTION_HISTORY}/${subscriptionId}`,
      {
        headers: {
          hospital_id: id,
          Authorization: token,
        },
      }
    );
    dispatch(setLoading(false));
    return response;
  } catch (error) {
    dispatch(setLoading(false));
    console.error('Error fetching subscription details:', error);
    throw error;
  }
};

export const getShelterList = async (
  id: string | number | undefined,
  token: any,
  dispatch: any
) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.get(`${backendURL}/${URL.GET_SHELTERS_LIST}`, {
      headers: {
        hospital_id: id,
        Authorization: token,
      },
    });
    dispatch(setLoading(false));
    return response;
  } catch (error) {
    dispatch(setLoading(false));
    console.error('Error fetching subscription details:', error);
    throw error;
  }
};

export const getClockInOutList = async (
  user_id: string | number,
  endDate: Date | string,
  startDate: Date | string,
  dispatch: any
) => {
  try {
    dispatch(setLoading(true));

    // Helper to format date string as 'YYYY-MM-DDTHH:mm:ss.SSS'
    const formatDateString = (dateStr: string, isStart: boolean) => {
      // Expecting dateStr in 'YYYY-MM-DD' or similar format
      const date = typeof dateStr === 'string' ? dateStr.slice(0, 10) : '';
      return isStart ? `${date}T00:00:00.000` : `${date}T23:59:59.999`;
    };

    const formattedStartDate = formatDateString(
      typeof startDate === 'string' ? startDate : startDate.toISOString(),
      true
    );
    const formattedEndDate = formatDateString(
      typeof endDate === 'string' ? endDate : endDate.toISOString(),
      false
    );

    const response = await apiInstance.get(
      `${URL.GET_CLOCK_IN_OUT_LIST.replace('{teamId}', String(user_id))}?end=${formattedEndDate}&start=${formattedStartDate}`
    );
    const clockInOutDataValues = transformClockInOutData(response?.data?.data);
    dispatch(setLoading(false));
    return clockInOutDataValues;
  } catch (error) {
    console.error('Error fetching subscription details:', error);
    throw error;
  }
};
